import * as firebaseUtil from "../../data/FirebaseUtil";
import app, {storage} from "../../authentication/firebaseStart";

const axios = require("axios");

const getToken = async () => {
    return (await app.auth().currentUser.getIdTokenResult()).token;
}

/**
 * exportCSVDataToGCSBucket export csv data to GCS bucket
 * @param fromdateVal
 * @param todateVal
 * @param endPoint
 * @param site
 * @param token
 * @returns {Promise<unknown[]>}
 */
const exportCSVDataToGCSBucket = async (fromdateVal, todateVal, endPoint, site, token) => {
    console.log("Token: ", token);
    let param = {
        "startDate": fromdateVal,
        "endDate": todateVal,
        "endPoint": endPoint,
        "token": token ? token.token : await getToken(),
        'site': site === 'All' ? 'all' : site
    };
    console.log("Params: [exportCSVDataToGCSBucket] :", param);
    let response = await firebaseUtil.exportCsvDataToGcsBucket(param)
    if (response.status === 'Success') {
        return [true, response]
    } else {
        return [false, response]
    }
}


/**
 * exportCSVDataToGCSBucketEventDetail export csv data to GCS bucket
 * @param fromdateVal
 * @param todateVal
 * @param endPoint
 * @param site
 * @param token
 * @returns {Promise<unknown[]>}
 */
const exportCSVDataToGCSBucketEventDetail = async (fromdateVal, todateVal, endPoint, site, token,category, subCategory, deviceStateUpdatedBy, siteMovementCategory) => {
    console.log("Token: ", token);
    let param = {
        "startDate": fromdateVal,
        "endDate": todateVal,
        "endPoint": endPoint,
        "token": token ? token.token : await getToken(),
        'siteName': site === 'All' ? 'all' : site,
        'category':category,
        'subCategory':subCategory,
        'deviceStateUpdatedBy':deviceStateUpdatedBy,
        'siteMovementCategory':siteMovementCategory
    };
    console.log("Params: [exportCSVDataToGCSBucket] :", param);
    let response = await firebaseUtil.exportCsvDataToGcsBucketEventDetail(param)
    if (response.status === 'Success') {
        return [true, response]
    } else {
        return [false, response]
    }
}

/**
 * uploadExportedDataToGCSBucket function that the upload exported csv data to gcs bucket
 * after successful exportCsvDataToGcsBucket request
 * @param filePath
 * @param endPoint
 * @param token
 * @returns {Promise<unknown[]>}
 */
const uploadExportedDataToGCSBucket = async (filePath, endPoint, token) => {
    if (filePath !== null && filePath !== "") {
        let data = {
            file_path: filePath,
            endPoint: endPoint,
            token: token ? token.token : await getToken(),
        }
        let response = await firebaseUtil.uploadZipFileToGcsBucket(data)
        if (response.statusCode === 400) {
            response = await firebaseUtil.uploadZipFileToGcsBucket(data)
        } else {
            if (response.status === 'Success') {
                return [true, response]
            } else {
                return [false, response]
            }
        }
    }
}

/**
 * downloadFile
 * @param fileName
 * @param url
 * @returns {Promise<void>}
 */
const downloadFile = async (fileName, url) => {
    axios.get(url, {
        method: "GET",
        responseType: "blob"
    }).then((response) => {
        console.log("DOWNLOAD FILE RESPONSE STATUS: ", response.status)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        console.log("DOWNLOAD FILE - ERROR RESPONSE :  ", error)
    })
};

/**
 * getURLFromGCSBucket
 * @param fileName
 * @returns {Promise<(boolean|string)[]>}
 */
const getURLFromGCSBucket = async (fileName) => {
    let msg = "";
    let isError = false;
    let startRef = storage.ref().child(fileName);
    await startRef.getDownloadURL()
        .then((url) => {
            async function downloadZipFile() {
                await downloadFile(fileName, url)
            }

            isError = false;
            msg = "File download complete";
            downloadZipFile();

            //return [true,'File download completed' ];
        }).catch((error) => {
            console.log("URL FETCHING [ERROR]:  ", error)
            // eslint-disable-next-line default-case
            switch (error.code) {
                case 'storage/object-not-found':
                    console.log('File does not exist');
                    isError = true;
                    msg = "File does not exist";
                    break;
                case 'storage/unauthorized':
                    console.log('User does not have permission to access the object');
                    isError = true;
                    msg = "User does not have permission to access the object";
                    break;
                case 'storage/canceled':
                    console.log('User canceled the upload')
                    isError = true;
                    msg = "User canceled the upload";
                    break;
                case 'storage/unknown':
                    console.log('Unknown error occurred, inspect the server response')
                    isError = true;
                    msg = "Unknown error occurred, inspect the server response";
                    break;
            }
        })
    return [isError, msg]
}

const buttonStatus = {
    'state1': 'initial',
    'state2': 'exportingInProgress',
    'state3': 'uploadInProgress',
    'state4': 'readyToDownload',
    'state5': 'downloadingInProgress',
    'state6': 'downloadCompleted',
}

export {
    downloadFile,
    exportCSVDataToGCSBucket,
    exportCSVDataToGCSBucketEventDetail,
    uploadExportedDataToGCSBucket,
    getURLFromGCSBucket,
    buttonStatus
} ;
